import React from 'react'
import { Loader } from '@manychat/manyui'

import cm from './styles.module.css'

export const PreparingDataLoader = ({ message }: { message: string }) => (
  <div className={cm.loader}>
    <Loader className="m-0" size={24} />

    <p className="m-t font-medium">{message}</p>
  </div>
)
